import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import React from 'react';
import { SLogo, SConfirmationIcon } from '../styles/Header.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ForgotPasswordConfirmationHeader: React.FC = () => {
  return (
    <>
      <SLogo>
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/billComposerCyan.svg `}
          height="80px"
          alt="CSG logo"
          id="imgBcLogo"
        />
      </SLogo>
      <SConfirmationIcon>
        <FontAwesomeIcon icon={faEnvelope} size="8x" color="#1eab6e" id="imgFaEnvelope" />
      </SConfirmationIcon>
    </>
  );
};

export default ForgotPasswordConfirmationHeader;
